// storageUtils.js
const PERSIST_KEYS = [
  'persist:auth', 'persist:user', 'persist:role', 'persist:location',
  'persist:plant', 'persist:report', 'persist:dashboard', 'persist:machine',
  'persist:product', 'persist:shift', 'persist:department', 'persist:dpmu',
  'persist:productVsDefect', 'persist:defect', 'persist:aismartview',
  'persist:defectTrigger', 'persist:loadingState'
];

export const handleRememberMeToggle = (rememberMe, persistor) => {
  console.log(`Remember Me: ${rememberMe}`);
  
  // Update preference
  localStorage.setItem("rememberMeClicked", rememberMe.toString());
  
  if (rememberMe) {
    // Move data from sessionStorage to localStorage
    PERSIST_KEYS.forEach(key => {
      const sessionData = sessionStorage.getItem(key);
      if (sessionData) {
        localStorage.setItem(key, sessionData);
        sessionStorage.removeItem(key); // Clean up
      }
    });
    console.log('Data moved to localStorage');
  } else {
    // Move data from localStorage to sessionStorage
    PERSIST_KEYS.forEach(key => {
      const localData = localStorage.getItem(key);
      if (localData) {
        sessionStorage.setItem(key, localData);
        localStorage.removeItem(key); // Clean up
      }
    });
    console.log('Data moved to sessionStorage');
  }
  
  // Flush persistor
  persistor?.flush();
  
};